import type { PostPublishJob, PostPublishGroupSnapshot, PostPublishStorageResult } from "./postPublishTypes";
import type { PostAuthorAttribution } from "./postPublishing";
import type { UploadedPostImage } from "./postAttachments";

// One creation contract for Native durable jobs and Web online text submission.
export function buildPostPublishPayload(
  job: PostPublishJob,
  canonicalAuthor: PostAuthorAttribution,
  group: PostPublishGroupSnapshot | null,
  images: UploadedPostImage[] = [],
  pdf?: PostPublishStorageResult,
) {
  if (job.visibility === "group" && !group) throw new Error("Groupe indisponible.");
  const jobAuthor = job.author as Partial<PostAuthorAttribution> | undefined;
  const jobIdentityId = typeof jobAuthor?.authorIdentityId === "string"
    ? jobAuthor.authorIdentityId
    : null;
  if (
    canonicalAuthor.authorUid !== job.authorUid
    || canonicalAuthor.authorIdentityId !== canonicalAuthor.authorSnapshot.identityId
    || (jobIdentityId !== null && canonicalAuthor.authorIdentityId !== jobIdentityId)
  ) {
    throw new Error("Attribution publique indisponible.");
  }
  return {
    authorUid: canonicalAuthor.authorUid,
    authorIdentityId: canonicalAuthor.authorIdentityId,
    authorSnapshot: canonicalAuthor.authorSnapshot,
    text: job.text,
    subject: job.subject,
    ...(job.track ? { track: job.track } : {}),
    likesCount: 0,
    likedBy: [],
    ...(images.length ? { images, attachmentType: "image" as const } : {}),
    ...(pdf ? {
      attachmentType: "pdf" as const,
      attachmentUrl: "",
      attachmentStoragePath: pdf.storagePath,
      attachmentName: pdf.name,
    } : {}),
    moderationStatus: "pending" as const,
    ...(job.visibility === "global"
      ? { visibility: "global" as const, groupId: null }
      : { visibility: "group" as const, groupId: group!.groupId, groupName: group!.groupName, groupIsPublic: group!.isPublic }),
  };
}
